import { render } from "./TituloInput.vue?vue&type=template&id=2128ceb0&scoped=true&ts=true"
import script from "./TituloInput.vue?vue&type=script&lang=ts"
export * from "./TituloInput.vue?vue&type=script&lang=ts"

import "./TituloInput.vue?vue&type=style&index=0&id=2128ceb0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2128ceb0"]])

export default __exports__